export default __webpack_public_path__ + "966106e7fc0236fb7245e3fe4546b4ee.svg";